import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=18f76348&scoped=true"
import script from "./Course.vue?vue&type=script&lang=ts"
export * from "./Course.vue?vue&type=script&lang=ts"
import style0 from "./course.css?vue&type=style&index=0&id=18f76348&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f76348",
  null
  
)

export default component.exports